import { render } from "./general-wellness-chart.vue?vue&type=template&id=17ea67ea&scoped=true"
import script from "./general-wellness-chart.vue?vue&type=script&lang=js"
export * from "./general-wellness-chart.vue?vue&type=script&lang=js"

import "./general-wellness-chart.vue?vue&type=style&index=0&id=17ea67ea&scoped=true&lang=css"

import exportComponent from "/Users/qmaura/PANOPTIC/hkust-gz-vitals/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17ea67ea"]])

export default __exports__